// @ts-nocheck
import { toast } from 'sonner';
import { Switch } from '@/components/ui/switch';
import CollapsibleSection from './CollapsibleSection';

export default function HumanHandoverSection({ enabled, onChange }: any) {
  const handleChange = (checked: boolean) => {
    onChange(checked);
    toast.success(checked ? 'Human Handover enabled' : 'Human Handover disabled');
  };

  return (
    <CollapsibleSection title="Human Handover" info="When on, the agent can transfer the call to a live person. When off, a request for a person ends the call and is reported as a completion type.">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-foreground">Human Handover</p>
          <p className="mt-1 text-xs text-muted-foreground">
            Automatically transfer the chat to a human agent when the bot cannot answer or the user
            requests it.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Switch checked={enabled} onCheckedChange={handleChange} aria-label="Human Handover" />
          <span className="text-sm text-muted-foreground">{enabled ? 'Enabled' : 'Disabled'}</span>
        </div>
      </div>
    </CollapsibleSection>
  );
}